var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconMenu01Outlined(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 11.8282C3 11.2977 3.21071 10.789 3.58579 10.414L10.5858 3.41391C11.3668 2.63286 12.6332 2.63286 13.4142 3.41391L20.4142 10.414C20.7893 10.789 21 11.2977 21 11.8282V19.9998C21 20.552 20.5523 20.9998 20 20.9998H14C13.4477 20.9998 13 20.552 13 19.9998V14.9998H11V19.9998C11 20.552 10.5523 20.9998 10 20.9998H4C3.44772 20.9998 3 20.552 3 19.9998V11.8282ZM4.64645 11.4746C4.55268 11.5684 4.5 11.6956 4.5 11.8282V19.4998H9.5V14.4997C9.5 13.9475 9.94772 13.4997 10.5 13.4997H13.5C14.0523 13.4997 14.5 13.9475 14.5 14.4997V19.4998H19.5V11.8282C19.5 11.6956 19.4473 11.5684 19.3536 11.4746L12.3536 4.47456C12.1583 4.2793 11.8417 4.2793 11.6464 4.47457L4.64645 11.4746Z",
    fill: "#A3A3A3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMenu01Outlined);
export default __webpack_public_path__ + "static/media/icon_menu01_outlined.2c98adfdf25d5d1a8a423d2cab807c00.svg";
export { ForwardRef as ReactComponent };